import React, { Component } from 'react'
import "../../../../css/general-style.css"
import '../../../../css/small-table-responsive.css'
import { NumberFormat } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';
import { AiOutlineWarning } from 'react-icons/ai';

export default class extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {

    }

    render() {
        // Get request status
        const { loading, error, Title } = this.props;

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }
        
        return (
            <div className='card'>
                <div className='card-body'>
                    <div className='row '>
                        <div className='col-sm-6'>
                            <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                        </div>
                        <div className='col-sm-12'>
                            <div className='pb-3' />
                            <div className="tableFixHeadSmall ">
                                <table className='table table-clean'>
                                    <thead>
                                        <tr>
                                            <th>Customer No</th>
                                            <th>Customer Name</th>
                                            <th>Credit Limit</th>
                                            <th>Current Balance</th>
                                            <th><AiOutlineWarning style={{marginRight:4}}/>Excess</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.data.map((order, o) => (
                                            <tr key={o}>
                                                <td>{order.CustomerNo}</td>
                                                <td>{order.CustomerName}</td>
                                                <td className='text-center'>${NumberFormat(pricesFormat(order.CreditLimit))}</td>
                                                <td className='text-center'>${NumberFormat(pricesFormat(order.CurrentBalance))}</td>
                                                <td className='text-center'>
                                                    <span className="dash-excess-badge">
                                                        <AiOutlineWarning />
                                                        ${NumberFormat(pricesFormat(order.Exceso))}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        )
    }
}
